<script setup lang="ts">
import CarouselMobile from '../../../CarouselMobile/CarouselMobile.vue';
import IMG_EXAMPLE_FRAME from '../../assets/example-background.png';
</script>

<template>
<div class="example">
  <CarouselMobile :mobileFrameImage="IMG_EXAMPLE_FRAME"/>
</div>
</template>
